import { set } from 'cerebral/operators'
export default [set('app.navigationOpen', true)]



// WEBPACK FOOTER //
// ./src/modules/user/chains/openNavigation.js